<template>
    <div class="cube-query-builder">
        <slot
            :query="query"
            :measures="measures"
            :dimensions="dimensions"
            :segments="segments"
            :timeDimensions="timeDimensions"
            :filters="filters"
            :updateQuery="updateQuery"
            :isQueryPresent="isQueryPresent"
        />
    </div>
</template>

<script>
import { QueryBuilder } from '@cubejs-client/vue';

export default {
    name: 'CubeQueryBuilder',
    extends: QueryBuilder,
    props: {
        query: {
            type: Object,
            default: () => ({})
        },
        cubeApi: {
            type: Object,
            required: false
        }
    },
    computed: {
        measures() {
            return this.query.measures || [];
        },
        dimensions() {
            return this.query.dimensions || [];
        },
        segments() {
            return this.query.segments || [];
        },
        timeDimensions() {
            return this.query.timeDimensions || [];
        },
        filters() {
            return this.query.filters || [];
        },
        isQueryPresent() {
            return this.measures.length > 0 || this.dimensions.length > 0;
        }
    },
    methods: {
        updateQuery(queryUpdate) {
            const newQuery = {
                ...this.query,
                ...queryUpdate
            };
            this.$emit('query-change', newQuery);
        }
    }
};
</script>
